import { render } from "./QuoteDocumentsCard.vue?vue&type=template&id=fa5f80fa"
import script from "./QuoteDocumentsCard.vue?vue&type=script&lang=js"
export * from "./QuoteDocumentsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__